import type React from 'react';
import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { PageLoading } from '@/app/components/page-loading.tsx';
import { useAuth } from '@/app/hooks/auth-provider';
import { UserTypeEnum } from '../../types/user-type.ts';

const LazyAdminUserList = lazy(() => import('./AdminUserList'));

const AdminUserList = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => {
  const { user: data } = useAuth();
  return (
    <Suspense fallback={<PageLoading />}>
      {data?.userType === UserTypeEnum.Admin ? (
        <LazyAdminUserList {...props} />
      ) : data?.userType === UserTypeEnum.DrugRep || data?.userType === UserTypeEnum.StaffMember ? (
        <Navigate to={'/dashboard'} />
      ) : null}
    </Suspense>
  );
};

export const adminUserListRoute = {
  path: '/admin-user-list',
  element: <AdminUserList />,
};

export default AdminUserList;
